import React from 'react';

interface InputComponentProps {
  label: string;
  type?: string;
  name: string;
  className?: string;
  value: string | number;
  placeholder?: string;
  onChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  readOnly?: boolean;
  required?: boolean;
  onKeyDown?: (e: React.KeyboardEvent<HTMLInputElement>) => void;
  disabled?: boolean;
  min?: string | number;
  max?: string | number;
}

const InputComponent: React.FC<InputComponentProps> = ({
  label,
  type = 'text',
  name,
  className = '',
  value,
  placeholder,
  onChange,
  readOnly = false,
  required = false,
  onKeyDown,
  disabled = false,
  min,
  max,
}) => {
  return (
    <div className={`input-container ${className}`}>
      <label htmlFor={name}>
        {label}
        {required && <span className="required"> *</span>}
      </label>
      <input
        type={type}
        name={name}
        id={name}
        value={value}
        onChange={onChange}
        placeholder={placeholder}
        readOnly={readOnly}
        required={required}
        onKeyDown={onKeyDown}
        disabled={disabled}
        min={min}
        max={max}
      />
    </div>
  );
};

export default InputComponent;